import { contains } from 'jquery';
import { lockScreenScroll } from '../utils/treatment';

const btnMenu = document.querySelector('.btn-menu');
const sidebarFixed = document.querySelector('.sidebar-fixed')

// FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
export function showNavbarDropdown(dropdown, content, index) {
  const dropdownSelected = document.querySelector(dropdown);
  const contentSelected = document.querySelectorAll(content);

  if(!dropdownSelected || !contentSelected){
    return
  }

  const dropdownIcon = dropdownSelected.querySelector('i');

  // show dropdown by clicking on navbar item
  dropdownSelected.addEventListener('click', () => {

    if(btnMenu.classList.contains('active')){
      btnMenu.classList.toggle('active');
      sidebarFixed.classList.toggle('d-flex');
      lockScreenScroll();
    }
    
    dropdownIcon.classList.toggle('rotate-element');
    dropdownSelected.classList.toggle('active');
    contentSelected[index].classList.toggle('d-flex');

    if(contentSelected[index].classList.contains('show-navbar-dropdown')){
      contentSelected[index].classList.remove('show-navbar-dropdown')
      contentSelected[index].classList.add('hide-navbar-dropdown')
      
    }else{
      contentSelected[index].classList.remove('hide-navbar-dropdown')
      contentSelected[index].classList.add('show-navbar-dropdown')
    }

    setTimeout(() => {
      contentSelected[index].classList.add('dropdown-active');
    }, 100);
  });

  // if dropdown active, add event to close on click outside
  document.addEventListener('click', (event) => {
    if(contentSelected[index].classList.contains('dropdown-active')) {
      let isClickInside = contentSelected[index].contains(event.target);

      if (!isClickInside) {
        dropdownIcon.classList.remove('rotate-element');
        dropdownSelected.classList.remove('active');

        contentSelected[index].classList.remove('d-flex');

        setTimeout(() => {
          contentSelected[index].classList.remove('dropdown-active');
          contentSelected[index].classList.remove('show-navbar-dropdown')
          contentSelected[index].classList.add('hide-navbar-dropdown')
        }, 100);
      }
    }
  });
}


// FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBARS
export function showSidebarDropdown(dropSidebar, contentSidebar, indexSidebar) {
  const dropdownSelected = document.querySelector(dropSidebar);
  const contentSelected = document.querySelectorAll(contentSidebar);
  

  let isDropdownOpen = false; // Variável para controlar se o dropdown está aberto

  if (window.innerWidth < 992) {

    dropdownSelected.addEventListener('click', ()=>{
      const dropdownIcon = dropdownSelected.querySelector('.icon-seta');
      contentSelected[indexSidebar].classList.toggle('d-flex');
      dropdownIcon.classList.toggle('rotate-element');
    });

  }else{
    dropdownSelected.addEventListener('mouseenter', () => {
      contentSelected[indexSidebar].classList.add('d-flex');
      isDropdownOpen = true;
    });
  
    dropdownSelected.addEventListener('mouseleave', () => {
      if (!isDropdownOpen) {
        contentSelected[indexSidebar].classList.remove('d-flex');
      }
    });
  
    contentSelected[indexSidebar].addEventListener('mouseenter', () => {
      isDropdownOpen = true;
    });
  
    contentSelected[indexSidebar].addEventListener('mouseleave', () => {
      isDropdownOpen = false;
      contentSelected[indexSidebar].classList.remove('d-flex');
    });
  
    dropdownSelected.addEventListener('mouseleave', () => {
      isDropdownOpen = false;
      contentSelected[indexSidebar].classList.remove('d-flex');
    });
  }


  
}


